import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  className?: string;
  isLight?: boolean;
}

export function Logo({ className = '', isLight = false }: LogoProps) {
  return (
    <Link to="/" className={`relative flex items-center space-x-2 ${className}`}>

      <img
        src={isLight ? "/logo-white.png" : "/logo.png"}
        alt="SynthoHosting"
        className="h-8 w-auto"
        loading="eager"
        fetchpriority="high"
      />
    </Link>
  );
}
